import { createSignal } from '@verclam/pulsar';

export type LogoOwnerTarget =
	| { readonly owner: 'account' }
	| { readonly owner: 'organization'; readonly organizationId: number };

/** `null` closes the panel; otherwise the owner whose logo is being edited. */
const logoSidebarSignal = createSignal<LogoOwnerTarget | null>(null);

export const openLogoSidebar = (target: LogoOwnerTarget): void => {
	logoSidebarSignal.value = target;
};

export const closeLogoSidebar = (): void => {
	logoSidebarSignal.value = null;
};

export default logoSidebarSignal;
